const Constants = {
  primary_color: "#050f66",
  secondary_color: "#ff6551",
  background_color: "rgb(245, 245, 245)",
  live_color: "#32CD32",
  idle_color: "#808080",
  user_type: {
    ADMIN: "ADMIN",
    USER: "USER",
    SUPER_ADMIN: "SUPER_ADMIN"
  },
  alert: {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info",
  }
};

export default Constants;
